import { useEffect } from 'react'
import { getStudioPickupBoardAsync } from '../redux/shop'
import { useAppDispatch, useAppSelector } from '../redux/store'

/** Polls the studio pickup board so the Shop tab badge stays current. */
export function useShopPoll() {
  const dispatch = useAppDispatch()
  const studioClinicId = useAppSelector((state) => state.studioAuth.studioDetails?.id)
  const legacyClinicId = useAppSelector((state) => state.studio.clinic?.id)
  const clinicId = studioClinicId || legacyClinicId

  useEffect(() => {
    if (!clinicId) return

    dispatch(getStudioPickupBoardAsync({ clinicId }))

    const interval = setInterval(() => {
      dispatch(getStudioPickupBoardAsync({ clinicId }))
    }, 15000)

    return () => clearInterval(interval)
  }, [clinicId, dispatch])
}
